<div class="searchbar-container" [ngClass]="rootClassName"
  (mouseleave)="onMouseOutFilter()"
  (mouseenter)="onMouseEnterFilter()"
>
  <form #searchForm="ngForm" class="searchbar-row" [ngClass]="{'collapsed': collapsed}">
    <img loading="lazy" src="{{iconsearch.src}}" alt="{{iconsearch.alt}}" class="searchbar-iconssearch" (click)="toggleInput()"/>
    <input #inputField
      class="searchbar-text paragraphmedium"
      id="search-text"
      aria-describedby="search-text"
      aria-label="Search through page content"
      ngModel [ngModelOptions]="{standalone: true}"
      #searchText="ngModel"
      type="search"
      placeholder="{{placeholder}}"
      autocomplete="off"
      spellcheck="false"
    >
  </form>
  @if (!collapsed && (searchText.value ?? []).length > 0) {
    <ul class="list-group list-group-flush">
      @for (keyword of keywords | searchFilter: searchText.value; track $index) {
        <li class="list-group-item"
          [ngClass]="{'selected': isSelected(keyword)}"
          nxSuperprepHighlight
          [searchedWord]="searchText.value"
          [content]="keyword"
          [styleToApply]="'color:red;'"
          [setTitle]="true"
          (click)="onSelect(keyword)"
        >
          {{keyword}}
        </li>
      }
    </ul>
  }
</div>
